document.addEventListener('DOMContentLoaded', () => {
  const link = document.querySelector('cmpr-footer-navigation').shadowRoot.getElementById('piwik-consent-form-link');
  if (!link) return;

  link.addEventListener('click', (event) => {
    event.preventDefault();
    ppms.cm.api('openConsentForm', () => {});
  });
});
